module.exports = __webpack_public_path__ + "static/img/chartBorderBg3.ea8a43e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chartBorderBg3.png
// module id = +0kB
// module chunks = 1